export default [
  // These are our own, we could work harder and allow any data-* prop, but this works for now
  'data-test',
  'data-testid',
  'data-test-selector',
  // The list of global HTML attributes that are also supported by React, camel-cased
  'accessKey',
  'className',
  'contentEditable',
  'contextMenu',
  'dir',
  'draggable',
  'hidden',
  'id',
  'lang',
  'style',
  'tabIndex',
  'title',
];
